class FragranceDirectory extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const input = this.querySelector('input[type="search"]');
    const cards = [...this.querySelectorAll('[data-house]')];
    const status = this.querySelector('[role="status"]');
    const loadMore = this.querySelector('[data-load-more]');
    const loadMoreButton = loadMore?.querySelector('[data-load-more-button]');
    // A reviews app renders its items after load and again on paging, so data-items are read at each search.
    const items = () => (this.dataset.items ? [...this.querySelectorAll(this.dataset.items)] : cards);
    const filter = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let count = 0;
      // A search covers every tile; an empty search returns to the loaded tiles.
      items().forEach((card) => {
        const text = card.dataset.house ?? card.textContent;
        card.hidden = query ? !text.toLocaleLowerCase().includes(query) : 'offPage' in card.dataset;
        if (!card.hidden) count++;
      });
      if (loadMore) loadMore.hidden = Boolean(query);
      status.textContent = count ? `${count} ${this.dataset.resultsLabel}` : this.dataset.emptyLabel;
      status.classList.toggle('visually-hidden', count > 0);
    };
    input.addEventListener('input', filter, { signal });
    input.addEventListener('search', filter, { signal });
    if (this.dataset.items) {
      const observer = new MutationObserver((mutations) => {
        if (input.value.trim() && mutations.some((mutation) => !status.contains(mutation.target))) filter();
      });
      observer.observe(this, { childList: true, subtree: true });
      signal.addEventListener('abort', () => observer.disconnect());
    }

    if (!loadMoreButton) return;
    // Reveals the next batch in place; without JavaScript the link opens ?page=N+1, which renders the same tiles.
    loadMoreButton.addEventListener('click', (event) => {
      event.preventDefault();
      const pending = cards.filter((card) => 'offPage' in card.dataset);
      const perPage = Number(loadMore.dataset.perPage);
      // A remainder shorter than a desktop row comes with this batch, as in the section.
      const batch = pending.length - perPage < 4 ? pending : pending.slice(0, perPage);
      batch.forEach((card) => {
        delete card.dataset.offPage;
        card.hidden = false;
      });

      const page = Number(loadMore.dataset.page) + 1;
      loadMore.dataset.page = String(page);
      const shown = cards.length - pending.length + batch.length;
      loadMore.querySelectorAll('[data-shown-count]').forEach((element) => (element.textContent = String(shown)));
      loadMore.style.setProperty('--load-more-progress', `${(shown / cards.length) * 100}%`);

      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      history.replaceState(history.state, '', url);
      url.searchParams.set('page', String(page + 1));
      loadMoreButton.href = url.pathname + url.search;
      loadMoreButton.hidden = shown >= cards.length;

      // Brand Directory cards are links; Collections tiles contain one.
      (batch[0]?.closest('a') ?? batch[0]?.querySelector('a'))?.focus({ preventScroll: true });
    }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('fragrance-directory')) customElements.define('fragrance-directory', FragranceDirectory);
